// 🚨 WE WILL REVISIT THE FACEBOOK AND GOOGLE LOGIN WHEN BOTH CLIENT AND SERVER ARE SERVED OVER HTTPS
// THERE ARE TWO handleFacebookLogin Functions. ONE IS COMMENTED OUT AND BOTH GIVE DIFFERENC CLIENT CONSOLE MESSAGES
// CHECK THE TWO WITH THE BACKEND AND SEE THE INTEGRATION THAT WORKS

import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
import { useDispatch } from "react-redux";
// import { useGoogleLoginMutation } from "../slices/authSlice";
import {
  useSendEmailCodeMutation,
  useVerifyEmailCodeMutation,
  useGoogleLoginMutation,
  useFacebookLoginMutation,
  useCompleteRegistrationMutation,
} from "../slices/authSlice";
import { setCustomer } from "../slices/customerSlice";
import Input from "../components/utilComponents/Input";
import PasswordInput from "../components/utilComponents/PasswordInput";
import MFAInput from "../components/utilComponents/MFAInput";
import Button from "../components/utilComponents/Button";
import Error from "../components/message/Error";
import Success from "../components/message/Success";
import SocialButton from "../components/utilComponents/SocialButton";
import { validateEmail, notEmpty, validatePassword } from "../utils/validation";
import logo from "../assets/images/logo.png";
import facebook from "../assets/images/facebook_login.svg";
import google from "../assets/images/google_login.svg";

const Signup = () => {
  const [step, setStep] = useState(1);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);
  const [facebookLoading, setFacebookLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [sendEmailCode] = useSendEmailCodeMutation();
  const [verifyEmailCode] = useVerifyEmailCodeMutation();
  const [googleLogin] = useGoogleLoginMutation();
  const [facebookLogin] = useFacebookLoginMutation();

  // const handleGoogleLogin = async () => {
  //   setGoogleLoading(true);
  //   alert("Google");
  //   setGoogleLoading(false);
  // };

  const handleGoogleLogin = async (response) => {
    setGoogleLoading(true);
    try {
      const token = response.credential;
      await googleLogin({ token }).unwrap();
      navigate("/", { replace: true });
    } catch (error) {
      setError("Google login failed. Please try again.");
    } finally {
      setGoogleLoading(false);
    }
  };

  // Facebook Login

  // const handleFacebookLogin = async () => {
  //   setFacebookLoading(true);
  //   window.FB.login(
  //     async (response) => {
  //       if (response.status === "connected") {
  //         const { accessToken, userID } = response.authResponse;
  //         try {
  //           await facebookLogin({ accessToken, userID }).unwrap();
  //           navigate("/", { replace: true });
  //         } catch (error) {
  //           setError("Facebook login failed. Please try again.");
  //         } finally {
  //           setFacebookLoading(false);
  //         }
  //       } else {
  //         setError("Facebook login failed. Please try again.");
  //         setFacebookLoading(false);
  //       }
  //     },
  //     { scope: "email,public_profile" },
  //   );
  // };

  const handleFacebookLogin = () => {
    setFacebookLoading(true);

    window.FB.login(
      (response) => {
        if (response.status === "connected") {
          const { accessToken, userID } = response.authResponse;

          // Call your backend API with accessToken and userID
          fetch("/api/customer/auth/facebook", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ accessToken, userID }),
          })
            .then((res) => res.json())
            .then((data) => {
              setFacebookLoading(false);
              if (data._id) {
                alert("Login successful");
                // Handle successful login (e.g., navigate to homepage)
                navigate("/");
              } else {
                alert("Login failed");
              }
            })
            .catch((error) => {
              console.error("Facebook login error:", error);
              setFacebookLoading(false);
            });
        } else {
          alert("Facebook login failed");
          setFacebookLoading(false);
        }
      },
      { scope: "email,public_profile" },
    );
  };

  // Step 1: Collect user details
  const handleContinueToStep2 = (e) => {
    e.preventDefault();
    if (!notEmpty(firstName) || !notEmpty(lastName)) {
      setError("First name and last name are required");
      return;
    }
    if (!notEmpty(phone)) {
      setError("Phone number is required");
      return;
    }
    if (!validateEmail(email)) {
      setError("Invalid email address");
      return;
    }
    setStep(2);
  };

  // Step 2: Validate password and send complete data to backend
  const handleCompleteSignup = async (e) => {
    e.preventDefault();
    const validation = validatePassword(password);
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    if (!validation.isValid) {
      setError(
        "Password must be at least 6 characters long and contain uppercase, lowercase, number, and special character",
      );
      return;
    }

    setLoading(true);
    setError("");
    setSuccess("");
    try {
      // Send user details to the backend and trigger email code sending
      await sendEmailCode({
        firstName,
        lastName,
        phoneNumber: phone,
        email,
        password,
      }).unwrap();
      setSuccess("Verification code sent to email");
      setStep(3);
    } catch (error) {
      setError(error?.data?.message || "Error during signup");
    } finally {
      setLoading(false);
    }
  };

  // Step 3: Verify email code
  // const handleVerifyEmailCode = async (e) => {
  //   e.preventDefault();

  //   if (!verificationCode || verificationCode.length !== 6) {
  //     setError("Invalid verification code");
  //     return;
  //   }

  //   setLoading(true);
  //   setError("");
  //   setSuccess("");
  //   try {
  //     // Verify the email code
  //     await verifyEmailCode({ email, code: verificationCode }).unwrap();
  //     setSuccess("Email verified successfully!");

  //     // Redirect to homepage after successful verification
  //     setTimeout(() => {
  //       navigate("/", { replace: true });
  //     }, 1000);
  //   } catch (error) {
  //     setError(error?.data?.message || "Error verifying email code");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // Step 3: Verify email code
  const handleVerifyEmailCode = async (e) => {
    e.preventDefault();

    if (!verificationCode || verificationCode.length !== 6) {
      setError("Invalid verification code");
      return;
    }

    setLoading(true);
    setError("");
    setSuccess("");
    try {
      // Verify the email code
      const response = await verifyEmailCode({
        email,
        code: verificationCode,
      }).unwrap();
      setSuccess("Email verified successfully!");

      // Store user data in Redux and localStorage
      dispatch(setCustomer(response));
      localStorage.setItem("info", JSON.stringify(response));

      // Redirect to homepage after successful verification
      setTimeout(() => {
        navigate("/", { replace: true });
      }, 1000);
    } catch (error) {
      setError(error?.data?.message || "Error verifying email code");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      {error && <Error message={error} onClose={() => setError("")} />}
      {success && <Success message={success} onClose={() => setSuccess("")} />}
      <div className="bg-white p-8 rounded-xl card w-[90vw] md:w-96">
        <img src={logo} alt="logo" className="mb-12 w-40 mx-auto" />

        {step === 1 && (
          <form onSubmit={handleContinueToStep2}>
            <Input
              placeholder="First name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
            <Input
              placeholder="Last name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
            <Input
              placeholder="Phone number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
            <Input
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Button type="submit" variant="primary" fullWidth>
              Continue
            </Button>
          </form>
        )}

        {step === 2 && (
          <form onSubmit={handleCompleteSignup}>
            <PasswordInput
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <PasswordInput
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <Button
              type="submit"
              variant="primary"
              fullWidth
              isLoading={loading}
            >
              Continue
            </Button>
          </form>
        )}

        {step === 3 && (
          <form onSubmit={handleVerifyEmailCode}>
            <MFAInput
              length={6}
              onComplete={setVerificationCode}
              message="Enter the code sent to your email"
            />
            <Button
              type="submit"
              variant="primary"
              fullWidth
              isLoading={loading}
            >
              Complete Registration
            </Button>
          </form>
        )}

        <p className="text-center text-sm text-agLightGray my-4">OR</p>
        {/* Google Login Button */}
        {/* <SocialButton
          icon={google}
          text="Continue with Google"
          onClick={handleGoogleLogin}
          isLoading={googleLoading}
        /> */}
        {/* <GoogleLogin
          onSuccess={handleGoogleLogin}
          onError={() => setError("Google login failed")}
          text="continue_with"
          shape="pill"
          theme="outline"
        /> */}

        {/* Facebook Login Button */}
        {/* <div className="mt-4">
          <SocialButton
            icon={facebook}
            text="Continue with Facebook"
            onClick={handleFacebookLogin}
            isLoading={facebookLoading}
          />
        </div> */}
        {/* <SocialButton
          icon={facebook}
          text="Continue with Facebook"
          onClick={handleFacebookLogin}
          isLoading={facebookLoading}
        /> */}

        <p className="mt-4 text-sm text-agLightGray text-center">
          Already have an account?{" "}
          <Link to="/login" className="text-agBlue">
            Login
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Signup;
